import {z} from "zod";
import {CUSTOMER_KEY_TYPE} from "../common/enum";

export const customerFormSchema = z.object({
	customerType: CUSTOMER_KEY_TYPE,
	storeName: z.string(),
	telephone: z.string(),
	representativeName: z.string()
});

export type CustomerFormType = z.infer<typeof customerFormSchema>;
